import request from "root/js/request";

export const getSubjectById = async ({id}) => {
  const response = await request({
    url: `parsers/subjects/${id}/`,
    method: "get",
  });
  return response.data;
};
